module.exports = __webpack_public_path__ + "img/45-white.e2d9fe1f.svg";